import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { langLink } from '../../../../../services/i18n-live';

/** A quiet bridge from lessons to independent theory practice. */
@Component({
  selector: 'app-home-band-lane',
  templateUrl: './home-band-lane.component.html',
  styleUrl: './home-band-lane.component.css',
})
export class HomeBandLaneComponent {
  private readonly translate = inject(TranslateService);

  link(route: string): string {
    return langLink(this.translate, route);
  }
}
